import { render, staticRenderFns } from "./service-object-detail.vue?vue&type=template&id=17a87c20&scoped=true&"
import script from "./service-object-detail.vue?vue&type=script&lang=js&"
export * from "./service-object-detail.vue?vue&type=script&lang=js&"
import style0 from "./service-object-detail.vue?vue&type=style&index=0&id=17a87c20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a87c20",
  null
  
)

export default component.exports